import { emailZodSchema, type Email } from "@@/shared/email";
import { addressZodSchema, type Address } from "@@/shared/locations/address";
import { phoneZodSchema, type Phone } from "@@/shared/phone";
import { z } from "zod";
import {
    deliveryZoneZodSchema,
    type DeliveryZone,
} from "../delivery-zone/delivery-zone";

type HomeDeliveryDestination = {
    readonly _type: "HOME_DELIVERY_DESTINATION";
    readonly recipientId: string;
    readonly recipientName: string;
    readonly type: "USER" | "PROVIDER";
    readonly contact: {
        readonly email: Email | undefined;
        readonly phone: Phone;
    };
    readonly notesToDeliverer: string;
    readonly addressDetails?: string;
    readonly deliveryZone: DeliveryZone;
    readonly address: Address;
};

const homeDeliveryDestinationZodSchema: z.ZodSchema<HomeDeliveryDestination> =
    z.object({
        _type: z.literal("HOME_DELIVERY_DESTINATION"),
        recipientId: z.string().min(1),
        recipientName: z.string().min(1),
        type: z.enum(["USER", "PROVIDER"]),
        contact: z.object({
            email: emailZodSchema,
            phone: phoneZodSchema,
        }),
        notesToDeliverer: z.string().min(1),
        addressDetails: z.string().optional(),
        deliveryZone: deliveryZoneZodSchema,
        address: addressZodSchema,
    });

export { homeDeliveryDestinationZodSchema };
export type { HomeDeliveryDestination };
